/* import __COLOCATED_TEMPLATE__ from './project-completion-expedite.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ICONS from 'sh-www/constants/assets/icons';
import { USER } from 'sh-www/models/user';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-project-completion-expedite';

class ProjectCompletionExpedite extends Component {
  @service session;

  @tracked isBuyerAcceptingExpediteFee = false;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get icons() {
    return ICONS;
  }

  get expeditePayoutFeeAmount() {
    switch (this.session.currentUser.type) {
      case USER.TYPES.BUYER:
        return this.args.billingRecord.buyerExpediteFee;
      case USER.TYPES.SELLER:
        return -(this.args.billingRecord.sellerExpediteFee);
      default:
        return 0.0;
    }
  }

  get expeditePayoutFeePercentageWholeNumber() {
    switch (this.session.currentUser.type) {
      case USER.TYPES.BUYER:
        return Number.parseFloat(this.args.billingRecord.feeStructure.buyerAdvanceFee) * 100;
      case USER.TYPES.SELLER:
        return Number.parseFloat(this.args.billingRecord.feeStructure.sellerAdvanceFee) * 100;
      default:
        return 0.0;
    }
  }

  get expediteRequestor() {
    return this.args.approvingAdvanceBillingRecord ?
      this.args.application.advanceShPaymentNeedsAgreement?.expediteRequestor
      : this.args.application.baseShPayment?.expediteRequestor;
  }

  get expediteText() {
    return this.session.currentUser.isBuyer
      ? 'Want to expedite payout to this freelancer?'
      : 'Want to expedite your payout?';
  }

  get isCheckboxDisabled() {
    if (this.args.application.expediteCommitment) {
      return true;
    }

    if (
      this.session.currentUser.isSeller
      && this.isExpeditedByOtherParty
    ) {
      return true;
    }

    return this.args.disabled;
  }

  get isExpeditedByBuyerText() {
    const { expediteRequestor } = this;
    if (this.args.billingRecord.approved) {
      return `This payment was expedited courtesy of ${expediteRequestor.firstName}`;
    }

    return `This payment is expedited by ${expediteRequestor.firstName} (Pending approval)`;
  }

  get isExpeditedBySellerText() {
    const { expediteRequestor } = this;
    return `${expediteRequestor.firstName} has requested to expedite their payment. Would you like to cover the expedite fee?`;
  }

  get isExpeditedByOtherParty() {
    const { expediteRequestor } = this;
    if (!this.args.billingRecord.expedite) return false;
    if (!expediteRequestor) return false;

    return expediteRequestor.type !== this.session.currentUser.type;
  }

  get isExpediteChecked() {
    if (this.session.currentUser.isBuyer && this.isExpeditedByOtherParty) {
      return this.isBuyerAcceptingExpediteFee;
    }

    return this.args.billingRecord.expedite;
  }

  get showExpediteFee() {
    if (this.session.currentUser.isSeller && this.isExpeditedByOtherParty) return false;
    return this.args.billingRecord.expedite;
  }

  @action
  handleCheckExpeditePayment() {
    if (this.session.currentUser.isBuyer  && this.isExpeditedByOtherParty) {
      this.isBuyerAcceptingExpediteFee = !this.isBuyerAcceptingExpediteFee;
      this.args.handleExpediteToggled(this.isBuyerAcceptingExpediteFee);
      return;
    }

    // dont handle as fee takeover
    this.args.handleExpediteToggled();
  }
}

export default ProjectCompletionExpedite;
